import productDisplay from './product-display/product-display.dir';
import campaignStates from './campaign-states/campaign-states.dir';
import productCarousel from './product-carousel/product-carousel.dir';
import productColorTransition from './product-color-transition/product-color-transition.dir';
import productDetails from './product-details/product-details.dir';
import productZoom from './product-zoom/product-zoom.dir';
import storeCtrl from './store.ctrl';

export default angular.module('cui.pages.sales', [])
  .controller('StoreCtrl', storeCtrl)
  .directive('productDisplay', productDisplay)
  .directive('campaignStates', campaignStates)
  .directive('productCarousel', productCarousel)
  .directive('productColorTransition', productColorTransition)
  .directive('productDetails', productDetails)
  .directive('productZoom', productZoom)
;



// WEBPACK FOOTER //
// ./source/client/pages/store/index.js